import React from "react";
import { motion } from "framer-motion";
import { Section, Reveal, Eyebrow, CTAButton, TrustBadges } from "./ui";
import { tomos } from "./data";
export function Tomos() {
  return <Section id="tomos" className="bg-[var(--calm-green)]/40" data-id="element-258" data-mp="1h2ug0pv6yhjv">
      <Reveal className="text-center" data-id="element-259" data-mp="1h575rp76xw7h">
        <Eyebrow data-id="element-260" data-mp="1cbuf79iybfc3">Los 6 Tomos</Eyebrow>
        <h2 className="mx-auto max-w-lg font-serif-display text-[1.7rem] font-semibold leading-tight text-[var(--ink)] sm:text-4xl" data-id="element-261" data-mp="1cat63alhx2x0">
          Tu guía clara para cada desafío cotidiano.
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm text-[var(--muted)]" data-id="element-262" data-mp="1m1nq08b9rqfa">
          Un sistema ordenado para saber qué consultar y cuándo.
        </p>
      </Reveal>

      <div className="mx-auto mt-6 grid max-w-lg grid-cols-2 gap-2.5 sm:mt-9 sm:grid-cols-3 sm:gap-5" data-id="element-263" data-mp="1w03jghxrrbry">
        {tomos.map((t, i) => <Reveal key={t.n} delay={i % 3 * 0.06} data-id="element-264" data-mp="5ofnmdpl08ky" data-mpi={i}>
            <motion.article whileHover={{
          y: -4
        }} transition={{
          type: "spring",
          stiffness: 300,
          damping: 20
        }} className="group relative flex h-full flex-col items-center overflow-hidden rounded-2xl border border-white bg-white px-3 pb-4 pt-3 text-center shadow-[0_14px_36px_-23px_rgba(31,51,69,0.48)] sm:rounded-3xl sm:px-5 sm:pb-5" data-id="element-265" data-mp="1mu62f23r64f">
              <span className="absolute left-2.5 top-2.5 z-10 flex h-6 w-6 items-center justify-center rounded-full bg-[var(--accent)] text-[10px] font-extrabold text-white shadow sm:left-4 sm:top-4 sm:h-7 sm:w-7 sm:text-xs" data-id="element-266" data-mp="3jfclqaj08dcy">
                {t.n}
              </span>
              <img src={t.img} alt={`Tomo ${t.n}: ${t.title}`} className="h-28 w-auto rounded-lg object-contain drop-shadow-lg transition-transform duration-500 group-hover:scale-105 sm:h-36" loading="lazy" data-id="element-267" data-mp="3sidp43ghjqcx" />
              <span className="mt-3 text-[9px] font-extrabold uppercase tracking-[0.14em] text-[var(--accent)] sm:text-[10px]" data-id="element-268" data-mp="233774ezcehub">
                Tomo {t.n}
              </span>
              <h3 className="mt-1 font-serif-display text-sm leading-tight text-[var(--ink)] sm:text-lg" data-id="element-269" data-mp="200j8qy3u43dl">
                {t.title}
              </h3>
              <p className="mt-2 hidden text-xs leading-relaxed text-[var(--muted)] sm:block" data-id="element-270" data-mp="29xxnmta40k3s">
                {t.desc}
              </p>
            </motion.article>
          </Reveal>)}
      </div>

      <Reveal delay={0.1} className="mt-7 text-center sm:mt-10" data-id="element-271" data-mp="2iydpxzf49l72">
        <CTAButton data-id="element-272" data-mp="2iwsxqgg9yecd">Quiero los 6 tomos hoy</CTAButton>
        <TrustBadges className="mt-5" compact data-id="element-273" data-mp="2extt6wyggjlg" />
      </Reveal>
    </Section>;
}